import * as React from "react";

export const LevelTen = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      stroke="#fff"
      strokeWidth={2.785}
      d="M34.465 13.925H16.014v9.747m0 0h8.703m-8.703 0v11.14"
    />
  </svg>
);
